import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { createRequestOption } from '../helpers/request-util';

@Injectable({
  providedIn: 'root'
})
export class NumeroRangoService {

  public resourceUrl = environment.apiUrl + 'camera/numeroRango';
  constructor(public http: HttpClient) { }

  create(numeroRango: any): Observable<any> {
    return this.http.post<any>(this.resourceUrl, numeroRango);
  }

  update(numeroRango: any): Observable<any> {
    return this.http.put<any>(this.resourceUrl, numeroRango);
  }

  find(id: number): Observable<any> {
    return this.http.get<any>(`${this.resourceUrl}/${id}`);
  }

  rangoInfo(id: number): Observable<any> {
    return this.http.get<any>(`${this.resourceUrl}/rangoInfo/${id}`);
  }

  query(req?: any): Observable<any> {
    const options = createRequestOption(req);
    return this.http.get<any[]>(this.resourceUrl, { params: options });
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`);
  }

}
